export default {
  baseStyle: {
    background: 'blue.900',
    color: 'white',
    '--popper-arrow-bg': '#1D295B',
  },
  defaultProps: {
    placement: 'top',
    hasArrow: true,
  },
}
